import React, { Component } from 'react'
import style from '../Component/Upload.Module.css'
// import cupload from '../Assets/verify/bi_upload.png'


export class Upload extends Component {  
state= {
    profileImg: 'https://cdn.pixabay.com/photo/2015/10/05/22/37/blank-profile-picture-973460_960_720.png'
}

 imageHandler = (e) => {
    const reader = new FileReader();
    reader.onload = () => {
        if(reader.readyState === 2){
            this.setState({profileImg: reader.result})
        }
    }
    reader.readAsDataURL(e.target.files[0])
} 
render () {
    const {profileImg} = this.state
        return (
 <div className={style.imageHolders}>
      <div className={style.imageHold}>
          <img src={profileImg} className={style.imag} alt=""/>
          </div>
  {/* <div className={style.imageHolderss}> */}
 {/* <img src={cupload} alt="upload icon"/>  */}
 <input type="file" className={style.imageUpload} name="image-Upload" id="input" accept="image/*" onChange={this.imageHandler}/>
 <div className={style.label}>
 <label htmlFor="input" className={style.imageUpload}>  Choose file</label>
</div>
</div>
 
                        
        )
    }
}



export default Upload